import React , {useEffect }from 'react'
import MockupImage from '../assets/web-view.png'

import apple from '../assets/icons8-apple-50.png'
import google from '../assets/icons8-google-play-48.png'
import huwaei from '../assets/icons8-huawei-48.png'

export default function Mockup() {

      useEffect(() => {
        if (window.AOS) {
          window.AOS.init({ duration: 300 });
        }
      }, []);
    


    return (
        <section id="DownloadSection" className='container mb-5' style={{ marginTop: '16rem' }} >
            <div className='mockup_section' >
                <img  data-aos="fade-up" className='mockup_image_margin' src={MockupImage} alt="mockup" />
                <h2  data-aos="fade-up" className='text-light mt-5 mb-4' >Download Now Gaming Pro Premium App</h2>

                <div  data-aos="fade-up" 
                 className='d-flex flex-row align-items-center justify-content-center gap-2 flex-wrap mb-5'
                //   className='d-flex flex-row align-items-center gap-2 flex-wrap mb-5'
                 >
                    <a className='os-button'  href='https://apps.apple.com/app/id1495934439' target='_blank'>
                        <img src={apple} alt="appstore" />
                        <div className='os-button-text'>
                            <span>Available in the</span>
                            <p>App Store</p>
                        </div>
                    </a>

                    <a className='os-button' href='https://play.google.com/store/apps/details?id=games.enjoy.box' target='_blank' >
                        <img src={google} alt="playstore" />
                        <div className='os-button-text' >
                            <span>Get it on</span>
                            <p>Google Play</p>
                        </div>
                    </a>


                    <a className='os-button' href='https://appgallery.huawei.com/#/app/C106192495' target='_blank'>
                        <img src={huwaei} alt="appgallery" />
                        <div className='os-button-text' >
                            <span>Explore it on</span>
                            <p>App Gallery</p>
                        </div>
                    </a>
                </div>
            </div>
        </section>
    )
}
